import React from "react";
import { Dashboard } from "../components/Dashboard";

export function DashboardPage() {

  return <Dashboard />;
}
